export const VENDORS_COMMODITIES_GETALL_PENDING =
  "VENDORS_COMMODITIES_GETALL_PENDING";

export const VENDORS_COMMODITIES_GETALL = "VENDORS_COMMODITIES_GETALL";

export const VENDORS_COMMODITIES_GETALL_SUCCESS =
  "VENDORS_COMMODITIES_GETALL_SUCCESS";

export const VENDORS_COMMODITIES_GETALL_ERROR =
  "VENDORS_COMMODITIES_GETALL_ERROR";

// export const VENDORS_COMMODITIES_GETDROPDOWN_PENDING =
//   "VENDORS_COMMODITIES_GETDROPDOWN_PENDING";

// export const VENDORS_COMMODITIES_GETDROPDOWN =
//   "VENDORS_COMMODITIES_GETDROPDOWN";

// export const VENDORS_COMMODITIES_GETDROPDOWN_SUCCESS =
//   "VENDORS_COMMODITIES_GETDROPDOWN_SUCCESS";

// export const VENDORS_COMMODITIES_GETDROPDOWN_ERROR =
//   "VENDORS_COMMODITIES_GETDROPDOWN_ERROR";
